const supplierLayout = {
  quotation: 'Inquiry sheet',
  pendingQuotation: 'To be quoted',
  resolveQuotation: 'Quoted',
  other: 'Other',
  purchaseOrder: 'Order',

  login: 'Login',
  loginTitle: 'Log in to WMS',
  acntNotExist: ' The account does not exist, please check',
  acntNotAvailable: 'The account already exists or has been disabled',
  loginFail: 'Login failed',
  updatePwd: 'Change password',
  pwd: 'Password',
  inputPwd: 'Please enter password',
  inputAct: 'Please enter your account',
  inputPwdSec: 'Please enter password again',
  confirmPwd: 'Confirm password',
  logOut: 'Log out',
  logOutTipTitle: 'Are you sure to log out',
  logOutTipContent: 'After confirming the exit, it will return to the login page',
  confirmTip: "Are you sure you want to decline the quotation for this inquiry?",
  confirmTip2: "After quoting, the purchaser will receive your quotation and may accept or reject it",
  pwdError: 'Password modification failed',
  editPwd: "Change Password",
  searchByKeyword: "Enter keywords to search",
  accountErr: "Wrong account or password",
  deliveryNotice:'Delivery Notice',
  business:'Business',
  reconciliation: 'Reconciliation',
  contract: 'Contract Management',
  quotations: 'Quotations',
  proQuotations: 'Product Quotations',
  myQuotations: 'My Quotations',
};

export default supplierLayout;